/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacySummaryDataLastActivityLabelSchema = z.enum(['messaged', 'stage_moved', 'applied', 'interview'])

export type CandidacySummaryDataLastActivityLabelSchema = z.infer<typeof candidacySummaryDataLastActivityLabelSchema>
